/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { workforce_CreateWorkContractRequest } from '../models/workforce_CreateWorkContractRequest';
import type { workforce_UpdateWorkContractRequest } from '../models/workforce_UpdateWorkContractRequest';
import type { workforce_WorkContractListResponse } from '../models/workforce_WorkContractListResponse';
import type { workforce_WorkContractResponse } from '../models/workforce_WorkContractResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkContractsService {
    /**
     * List work contracts for an employee
     * Get paginated list of work contracts for a specific employee
     * @param employeeId Employee ID
     * @param limit Maximum number of results (default: 20, max: 100)
     * @param offset Offset for pagination (default: 0)
     * @returns workforce_WorkContractListResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkContracts(
        employeeId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<workforce_WorkContractListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/work-contracts',
            query: {
                'employee_id': employeeId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Missing or invalid parameters`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list work contracts`,
            },
        });
    }
    /**
     * Create a work contract
     * Create a new work contract for an employee
     * @param request Work contract data
     * @returns workforce_WorkContractResponse Created
     * @throws ApiError
     */
    public static postApiV1WorkContracts(
        request: workforce_CreateWorkContractRequest,
    ): CancelablePromise<workforce_WorkContractResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/work-contracts',
            body: request,
            errors: {
                400: `Validation errors (including vacation_days_per_year / vacation_days_by_year field errors) or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                409: `Contract dates overlap with an existing contract`,
                500: `Failed to create work contract`,
            },
        });
    }
    /**
     * Delete a work contract
     * Soft delete a work contract
     * @param id Work contract ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1WorkContracts(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/work-contracts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing work contract ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Work contract not found`,
                500: `Failed to delete work contract`,
            },
        });
    }
    /**
     * Get work contract by ID
     * Get a single work contract by ID
     * @param id Work contract ID
     * @returns workforce_WorkContractResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkContracts1(
        id: string,
    ): CancelablePromise<workforce_WorkContractResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/work-contracts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing work contract ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Work contract not found`,
                500: `Failed to get work contract`,
            },
        });
    }
    /**
     * Update a work contract
     * Update an existing work contract with optimistic locking
     * @param id Work contract ID
     * @param request Updated work contract data
     * @returns workforce_WorkContractResponse OK
     * @throws ApiError
     */
    public static putApiV1WorkContracts(
        id: string,
        request: workforce_UpdateWorkContractRequest,
    ): CancelablePromise<workforce_WorkContractResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/work-contracts/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors (including vacation_days_per_year / vacation_days_by_year field errors) or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Work contract not found`,
                409: `Work contract was modified by another user or dates overlap`,
                500: `Failed to update work contract`,
            },
        });
    }
}
